import { Box } from '@customerio/pluma-components/react';
import { useSignupFlow } from '../signup-flow';
import { EmailEntryForm } from './email-entry-form';
import { SignupStartupForm } from './signup-startup-form';
import { useEntryStepArrival } from './use-entry-step-form';

export function IndexStep() {
  const { isStartup } = useSignupFlow();
  useEntryStepArrival();

  return <Box data-testid="signup-step-index">{isStartup ? <SignupStartupForm /> : <EmailEntryForm />}</Box>;
}
